import { render, staticRenderFns } from "./TechnicianListHandler.vue?vue&type=template&id=3a7bcff6"
import script from "./TechnicianListHandler.vue?vue&type=script&lang=ts"
export * from "./TechnicianListHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports